<template>
  <section class="bg-sky-950 text-white py-20 fade-in-on-scroll min-h-[300px]" v-stagger-fade>
    <div class="max-w-7xl mx-auto px-4 text-center fade-in-on-scroll" v-scroll-fade>
      <h2 class="text-3xl font-bold mb-12">What I Do</h2>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-10 text-left">
        <InfoCard
          emoji="📈"
          title="Strategy Automation"
          description="Turn your ideas into powerful, optimized Expert Advisors. No fluff — just results."
        />
        <InfoCard
          emoji="🔁"
          title="Pine Script ↔ MQL5"
          description="Accurate, clean code conversion that preserves your strategy logic — no shortcuts."
        />
        <InfoCard
          emoji="🧠"
          title="1-on-1 Consultations"
          description="Real-time guidance, deep dives into code, or strategy feedback — trader to trader."
        />
      </div>

      <div class="mt-8">
        <router-link
          to="/services"
          class="inline-block bg-white text-black hover:bg-sky-900 hover:text-white font-semibold px-6 py-3 rounded-lg transition duration-300"
        >
          Explore All Services
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import InfoCard from '@/components/InfoCard.vue';

export default {
  components: {
    InfoCard
  }
};
</script>
